// @ts-expect-error - @return-rabbit/nexus module declaration is not yet available
import { Details } from '@return-rabbit/nexus';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';

import { Button } from 'ui-components/components/button';
import { FlexRow, Gap } from 'ui-components/components/flex';
import { noop } from 'ui-components/default-props/noop';

import { useStepDetectiveContext } from '../../../../../components/csv-import/ui/components/step-detective/step-detective-context';

import { messages } from './messages';
import style from './style.module.less';

type ConfigureReturnStepFooterProps = {
  onCancel?: () => void;
};

export const ConfigureReturnStepFooter = ({ onCancel = noop }: ConfigureReturnStepFooterProps) => {
  const { goToPrevious } = useStepDetectiveContext();
  const { onConfirm, isProcessing, isDisabled } = Details.useConfirmRequest();
  const disabled = isProcessing || isDisabled;

  return (
    <FlexRow className={style['button-group']} gap={Gap.Space8}>
      <Button className={style['back-button']} onClick={() => goToPrevious()} theme='link'>
        <FontAwesomeIcon className={style['arrow-icon']} icon={faArrowLeft} />
        <FormattedMessage {...messages.back} />
      </Button>
      <FlexRow gap={Gap.Space8}>
        <Button onClick={onCancel} theme='tertiary'>
          <FormattedMessage {...messages.cancel} />
        </Button>
        <Button disabled={disabled} onClick={onConfirm} theme='primary'>
          <FormattedMessage {...messages.confirmRequest} />
        </Button>
      </FlexRow>
    </FlexRow>
  );
};
